import { keysWithMap } from '@infl-ts/util-io-ts';
import { makeHubApiRequest } from '@infl-ts/util-use-hub-api';
import * as DE from '@nll/datum/lib/DatumEither';
import axios from 'axios';
import * as A from 'fp-ts/Array';
import { constVoid } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Str from 'fp-ts/string';
import * as t from 'io-ts';
import { useEffect, useState } from 'react';
export var Permission = keysWithMap({
  corporate_access: 'CorporateAccess',
  member_interactions_access: 'MemberInteractionsAccess',
  view_lens: 'ViewLens'
});
export var PermissionsResult = t.type({
  data: t.array(t.string)
});
export var includesPermission = function includesPermission(permission) {
  return function (permissions) {
    return A.elem(Str.Eq)(permission, permissions);
  };
};
export var isActualAdmin = function isActualAdmin(_ref) {
  var isAdmin = _ref.isAdmin,
      isClone = _ref.isClone;
  return isAdmin && !isClone;
};
var permissionsCache = new Map();
export var useAdminPermissions = function useAdminPermissions(profile, jwt, currentHubURL) {
  var _permissionsCache$get;

  var args = JSON.stringify([profile === null || profile === void 0 ? void 0 : profile.id, jwt, currentHubURL]);

  var _useState = useState((_permissionsCache$get = permissionsCache.get(args)) !== null && _permissionsCache$get !== void 0 ? _permissionsCache$get : []),
      permissions = _useState[0],
      setPermissions = _useState[1];

  useEffect(function () {
    if (permissionsCache.has(args) || A.isNonEmpty(permissions)) {
      return;
    }

    permissionsCache.set(args, []);

    var _axios$CancelToken$so = axios.CancelToken.source(),
        cancelToken = _axios$CancelToken$so.token,
        cancel = _axios$CancelToken$so.cancel;

    makeHubApiRequest({
      jwt: jwt,
      currentHubURL: currentHubURL,
      method: 'get',
      url: '/permissions',
      outputCodec: PermissionsResult,
      cancelToken: cancelToken,
      onData: DE.squash(constVoid, function () {
        return permissionsCache["delete"](args);
      }, function (_ref2) {
        var data = _ref2.data;
        permissionsCache.set(args, data);
        setPermissions(data);
      })
    });
    return function () {
      var _permissionsCache$get2;

      cancel();

      if (A.isEmpty((_permissionsCache$get2 = permissionsCache.get(args)) !== null && _permissionsCache$get2 !== void 0 ? _permissionsCache$get2 : [])) {
        permissionsCache["delete"](args);
      }
    };
  }, [args]);
  return O.fromNullable(permissions);
};